import axios from 'axios'
var parseLinkHeader = require('parse-link-header')

const getAppNetStates = (context, payload = {page: 1}) => {
  axios
    .get(`application_network_states?page=${payload.page}`, {
      data: {},
    })
    .then(response => {
      context.commit('APP_NET_LIST_VIEW_UPDATED', {
        headerLinks: parseLinkHeader(response.headers.link),
        total: response.headers.total,
        perPage: response.headers['per-page'],
        context: 'Application Networks',
      })
      context.commit('APP_NET_STATES_UPDATED', response.data)
    })
    .catch(error => {
      // eslint-disable-next-line
    console.error(error)
    })
}

const getAppNetRevisions = (context, payload = {page: 1}) => {
  axios
    .get(`application_networks/${payload.id}/revisions?page=${payload.page}`, {
      data: {},
    })
    .then(response => {
      context.commit('APP_NET_REVISIONS_VIEW_UPDATED', {
        headerLinks: parseLinkHeader(response.headers.link),
        total: response.headers.total,
        perPage: response.headers['per-page'],
        context: 'Application Network Revisions',
        collectionId: payload.id,
      })
      context.commit('APP_NET_REVISIONS_UPDATED', response.data)
    })
    .catch(error => {
      // eslint-disable-next-line
      console.error(error)
    })
}

const setAppNetState = (context, data) => {
  context.commit('APP_NET_STATE_UPDATED', data)
}

const getAppNetState = (context, payload) => {
  axios
    .get(`application_network_states/${payload.id}`, {
      data: {},
    })
    .then(response => {
      context.commit('APP_NET_STATE_UPDATED', response.data.data)
    })
    .catch(error => {
      // eslint-disable-next-line
    console.error(error)
    })
}

const updateAppNetState = (context, payload) => {
  axios
    .put(`application_network_states/${payload.data.id}`, {
      data: payload.data,
    })
    .then(response => {
      context.commit('APP_NET_STATE_UPDATED', response.data.data)
    })
    .catch(error => {
      // eslint-disable-next-line
      console.error(error)
      context.commit('USER_ERROR', error.message)
    })
}

const clearUserError = context => {
  context.commit('USER_ERROR', null)
}

const getApplicationNetworkState = async (context, payload) => {
  let fetchApplicationNetworkPromise
  try {
    fetchApplicationNetworkPromise = await axios.get(
      `/application_networks/${payload.id}`
    )
    context.commit(
      'SET_APPLICATION_NETWORK_STATE',
      fetchApplicationNetworkPromise.data.data
    )
  } catch (error) {
    return Promise.reject(error)
  }
  return fetchApplicationNetworkPromise
}

const updateApplicationNetworkState = async (context, payload) => {
  let updateApplicationNetworkPromise
  try {
    updateApplicationNetworkPromise = await axios.patch(
      `/application_networks/${payload.id}`,
      {
        data: {
          type: 'users',
          attributes: payload.attributes,
        },
      }
    )
    context.commit('UPDATE_APPLICATION_NETWORK_STATE', payload)
  } catch (error) {
    return Promise.reject(error)
  }
  return updateApplicationNetworkPromise
}

export default {
  getAppNetStates,
  getAppNetRevisions,
  setAppNetState,
  getAppNetState,
  updateAppNetState,
  clearUserError,
  getApplicationNetworkState,
  updateApplicationNetworkState,
}



// WEBPACK FOOTER //
// ./src/modules/applicationNetworkStates/store/actions.js